import React from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import '../style.css';
import { ThemeContext } from '../../../context/theme.context';
import TabPane from './TabPane';
interface IState {
  currentIcon: any;
  status: boolean;
}

export default class Splitter extends React.Component<{}, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  constructor(props: any) {
    super(props);
    this.state = {
      currentIcon: <FaAngleDown size='12px' />,
      status: false,
    };
  }
  expand() {
    var element = document.getElementById('expandable');
    if (this.state.status) {
      element?.classList.remove('layoutExpand');
      element?.classList.add('layoutCollapse');
    } else {
      element?.classList.remove('layoutCollapse');
      element?.classList.add('layoutExpand');
    }
    this.setState({ status: !this.state.status });
  }
  render() {
    return (
      <div>
        <div className='main' onClick={this.expand.bind(this)}>
          {this.state.currentIcon}
        </div>
        <div id='expandable' className='layout'>
          {this.state.status ? <TabPane /> : null}
        </div>
      </div>
    );
  }
}
